import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store, { persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import "../public/font/stylesheet.css";
import "./index.css";
import App from "./App";
import { theme } from "./theme/Theme";
import { ThemeProvider } from "@mui/material";
import { ApolloProvider } from "@apollo/client";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n/config";
// @ts-ignore
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import {
  reactQueryClient,
  reactQueryPersister,
  ReactQueryPersistGate,
} from "./startup/reactQuery";
import { apolloClient } from "./startup/apollo";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
const googleClientId =
  "414962441078-2na4nvlo0lkgg4617ecg43vjtekbb6nh.apps.googleusercontent.com";
// index.js or App.js

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/service-worker.js")
    .then((registration) => {
      console.log("Service Worker registered with scope:", registration.scope);
      // You can optionally store the registration object
    })
    .catch((error) => {
      console.error("Service Worker registration failed:", error);
    });
}

root.render(
  <ApolloProvider client={apolloClient}>
    <PersistQueryClientProvider
      persistOptions={{ persister: reactQueryPersister }}
      client={reactQueryClient}
    >
      <ReactQueryPersistGate>
        <BrowserRouter>
          <Provider store={store}>
            <PersistGate persistor={persistor}>
              <ThemeProvider theme={theme}>
                <I18nextProvider i18n={i18n}>
                  <GoogleOAuthProvider clientId={googleClientId}>
                    <App />
                  </GoogleOAuthProvider>
                </I18nextProvider>
              </ThemeProvider>
            </PersistGate>
          </Provider>
        </BrowserRouter>
      </ReactQueryPersistGate>
    </PersistQueryClientProvider>
  </ApolloProvider>
);
